import { useSelector } from 'react-redux';
import { getSocialTags } from '../../selectors/salesChannelsSelectors';

function useGetSocialTags(): string {
  return useSelector(getSocialTags);
}

export default useGetSocialTags;
